import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { entityStateZodSchema } from "@@/shared/entity-status";
import {
    channexBookingIdFactory,
    channexBookingIdZodSchema,
} from "@@/shared/providers/integrations/channex/channex-booking-id";
import type { Except } from "type-fest";
import { z } from "zod";

const channexBookingZodObject = z.object({
    _id: channexBookingIdZodSchema,
    _type: z.literal("CHANNEX_BOOKING"),
    _createdAt: isoAndUnixZodSchema,
    _status: entityStateZodSchema,

    processed: z.boolean(),

    data: z.any(), //Replace with real schema

    error: z.string().optional(),
});

type ChannexBooking = z.infer<typeof channexBookingZodObject>;

type MappingFactoryParams = Except<
    ChannexBooking,
    "_id" | "_createdAt" | "_type" | "_status"
>;
const channexBookingFactory = (input: MappingFactoryParams): ChannexBooking => {
    return {
        ...input,
        _id: channexBookingIdFactory(),
        _type: "CHANNEX_BOOKING",
        _createdAt: nowIsoAndUnix(),
        _status: "ACTIVE",
        processed: false,
    };
};

export { channexBookingFactory, channexBookingZodObject };

export type { ChannexBooking };
